import imgCustomerService from '../img/Products/AI/ai-customer-service-icon.svg';
import imgDocumentMgmt from '../img/Products/AI/ai-document-mgmt.jpg';
import imgOcrFlow from '../img/Products/AI/ai-ocr-flow.jpg';
import imgComponentPricing from '../img/Products/AI/ai-component-pricing.jpg';

const aiServices = [
    {
        id: 'customer-service',
        title: 'AI 智能客服系統',
        titleEn: 'AI Omnichannel Customer Service System',
        image: imgCustomerService,
        imageAlt: 'AI 智能客服圖示',
        imageFit: 'contain',
        tag: '智能客服',
        overview:
            '專為零售、電商與製造業打造的全通路 AI 客服核心。打破傳統客服機器人只能依關鍵字死板回覆的限制，本系統導入最新大型語言模型（LLM），能精準理解客戶的真實意圖與語意脈絡。',
        advantages: [
            {
                label: '進銷存深度整合',
                text: '串接企業內部進銷存與訂單系統，AI 機器人能自動幫客戶查詢即時庫存、追蹤物流出貨進度，並能依據歷史銷售紀錄進行智能推薦。',
            },
            {
                label: '全通路語意理解',
                text: '整合 LINE、官網 Chatbot、FB Messenger，提供 24/7 不間斷的擬真人對答，自動分流 80% 的常見重複性問題。',
            },
            {
                label: '人機協作無縫接軌',
                text: '當遇到客製化特殊規格或複雜客訴時，AI 會自動彙整對話摘要，一鍵流暢轉接給真人客服。',
            },
        ],
    },
    {
        id: 'document-mgmt',
        title: 'AI 文件管理系統',
        titleEn: 'AI-Powered Document Management System',
        image: imgDocumentMgmt,
        imageAlt: '企業文件與知識庫管理',
        tag: '知識庫',
        overview:
            '將企業沉睡的文檔資產，轉化為隨問隨答的「企業專屬知識庫」。透過進階的 RAG（檢索增強生成）技術，讓員工用自然語言就能在數秒內找到答案。',
        advantages: [
            {
                label: '企業級安全架構',
                text: '支援企業地端資料庫（如 SQL Server Always Encrypted / PostgreSQL），確保研發、財務等機密文檔在 AI 訓練與檢索過程中絕不外洩。',
            },
            {
                label: '自然語言語意搜尋',
                text: '拋棄傳統死板的檔名關鍵字搜尋。輸入自然語句，AI 自動跨文件整合並生成精準解答與出處。',
            },
            {
                label: '智慧權限隔離',
                text: '系統具備嚴密的權限階層控管，AI 會根據查詢員工的職級身份，自動遮蔽或隔離敏感資料。',
            },
        ],
    },
    {
        id: 'ocr-flow',
        title: 'AI 文件辨識管理系統',
        titleEn: 'AI Document OCR & Flowchart Generator',
        image: imgOcrFlow,
        imageAlt: '文件整理與數位歸檔',
        tag: '文件辨識',
        overview:
            '專注於將「非結構化文檔」自動化、結構化的超級數位員工。不僅能精準辨識複雜的 PDF、Word 或紙本掃描檔，還能理解文件邏輯並自動生成視覺化工作流。',
        advantages: [
            {
                label: '自動化 SOP 流程轉化',
                text: '將厚重的文字版標準作業程序（SOP）文件，自動解析並一鍵轉換為結構清晰的 Mermaid 視覺化流程圖。',
            },
            {
                label: '多格式高精度辨識',
                text: '無論是採購單、報價單還是規格書，AI 能自動抓取關鍵欄位並校正傾斜與模糊字體。',
            },
            {
                label: '自動化歸檔與標籤',
                text: '辨識完成後，AI 會自動為文件下達多維度標籤，並歸類至對應的系統目錄，免去人工建檔的繁瑣與失誤。',
            },
        ],
    },
    {
        id: 'component-pricing',
        title: 'AI 電子零件查價管理系統',
        titleEn: 'AI Electronic Component Pricing & Procurement Intelligence',
        image: imgComponentPricing,
        imageAlt: '電子零件與科技製造',
        tag: '採購 intelligence',
        overview:
            '專為電子製造、代工、BOM 表估價團隊設計的採購決策大腦。系統透過高效 API 與全球最大電子零件資料庫（如 Nexar / Octopart GraphQL）以及多方供應商即時串接，實現一鍵自動化全球查價與比價。',
        advantages: [
            {
                label: '一鍵 BOM 表智慧估價',
                text: '上傳整份電子零件清單（BOM 表），AI 自動解析型號，並在數秒內帶出全球主要代理商的即時價格、庫存量與交期（Lead Time）。',
            },
            {
                label: '多維度權限與加權計算',
                text: '內建智能比價演算法，可依交期優先、價格優先或偏好特定原廠等策略，自動進行供應商加權評分與最佳化推薦。',
            },
            {
                label: '替代料智慧推薦',
                text: '當特定晶片或零件大缺貨時，AI 會主動分析規格書，精準推薦符合 Pin-to-Pin 與電氣特性的替代料件與即時報價，確保產線不停工。',
            },
        ],
    },
];

export const aiServiceIntro = {
    title: 'AI 應用系統服務',
    subtitle:
        '以 LLM、RAG 與自動化流程，協助企業提升客服、知識管理、文件處理與採購決策效率；AI 應用可串接進銷存與訂單系統，讓智能客服與庫存查詢在同一平台完成。',
    highlights: [
        { label: '智能客服', id: 'customer-service' },
        { label: '企業知識庫', id: 'document-mgmt' },
        { label: '文件辨識', id: 'ocr-flow' },
        { label: 'BOM 查價', id: 'component-pricing' },
    ],
};

export default aiServices;
